/* ============================================================
   ML OFFERS STRIP — multi-instance, observer-driven
   Auto-binds any [data-ml-offers-root] that appears in the DOM,
   including widgets injected into the quick-view modal.
   ============================================================ */
(function () {
  'use strict';

  if (window.__mlOffersStripLoaded) return;
  window.__mlOffersStripLoaded = true;

  const TAG_ICON = '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#27334c" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6.5 7.5a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"></path><path d="M3 6v5.172a2 2 0 0 0 .586 1.414l7.71 7.71a2.41 2.41 0 0 0 3.408 0l5.592 -5.592a2.41 2.41 0 0 0 0 -3.408l-7.71 -7.71a2 2 0 0 0 -1.414 -.586h-5.172a3 3 0 0 0 -3 3"></path></svg>';

  const ML_OFFERS = [
    { icon: TAG_ICON, title: 'Get Flat 5% Off', sub: 'Use Code: GIL5 on all orders',  code: 'GIL5' },
    { icon: TAG_ICON, title: 'Free Shipping',  sub: 'Available on all prepaid orders', code: null },
    { icon: TAG_ICON, title: 'Extra 5% Discount',   sub: 'Automatically applied on orders above ₹5,000', code: null }
  ];

  function initWidget(root) {
    if (!root || root.hasAttribute('data-ml-offers-bound')) return;
    root.setAttribute('data-ml-offers-bound', '1');

    const track = root.querySelector('[data-ml-offers="track"]');
    if (!track) return;

    // Render cards
    track.innerHTML = '';
    ML_OFFERS.forEach(function (offer, i) {
      const card = document.createElement('div');
      card.className = 'ml-ocard';
      card.innerHTML =
        "<div class='ml-ocard-icon'>" + offer.icon + "</div>" +
        "<div class='ml-ocard-body'>" +
          "<div class='ml-ocard-title'>" + offer.title + "</div>" +
          "<div class='ml-ocard-sub'>"   + offer.sub   + "</div>" +
        "</div>" +
        (offer.code
          ? "<button class='ml-ocard-apply' data-ml-apply-offer='" + i + "'>" +
              "Apply <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2.5'><polyline points='9 18 15 12 9 6'></polyline></svg>" +
            "</button>"
          : '');
      track.appendChild(card);
    });

    // Click → copy code
    root.addEventListener('click', function (e) {
      const btn = e.target.closest('[data-ml-apply-offer]');
      if (!btn || !root.contains(btn)) return;
      e.stopPropagation();
      const idx = parseInt(btn.getAttribute('data-ml-apply-offer'), 10);
      const offer = ML_OFFERS[idx];
      if (!offer || !offer.code) return;

      try {
        navigator.clipboard.writeText(offer.code);
      } catch (err) {
        const ta = document.createElement('textarea');
        ta.value = offer.code;
        document.body.appendChild(ta);
        ta.select();
        try { document.execCommand('copy'); } catch (e2) {}
        document.body.removeChild(ta);
      }
      const orig = btn.innerHTML;
      btn.innerHTML = '✓ Copied!';
      setTimeout(function () { btn.innerHTML = orig; }, 1500);
    });

    // Drag scroll
    let isDown = false, startX, scrollLeft;
    track.addEventListener('mousedown', e => {
      isDown = true;
      startX = e.pageX - track.offsetLeft;
      scrollLeft = track.scrollLeft;
    });
    track.addEventListener('mouseleave', () => { isDown = false; });
    track.addEventListener('mouseup',    () => { isDown = false; });
    track.addEventListener('mousemove', e => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - track.offsetLeft;
      const walk = (x - startX) * 2;
      track.scrollLeft = scrollLeft - walk;
    });
  }

  function bindAll(scope) {
    const root = scope || document;
    const candidates = root.querySelectorAll
      ? root.querySelectorAll('[data-ml-offers-root]:not([data-ml-offers-bound])')
      : [];
    candidates.forEach(initWidget);
    if (root.matches && root.matches('[data-ml-offers-root]:not([data-ml-offers-bound])')) {
      initWidget(root);
    }
  }

  function startObserver() {
    bindAll(document);
    const mo = new MutationObserver(function (mutations) {
      for (let i = 0; i < mutations.length; i++) {
        const m = mutations[i];
        for (let j = 0; j < m.addedNodes.length; j++) {
          const node = m.addedNodes[j];
          if (node.nodeType !== 1) continue;
          bindAll(node);
        }
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserver);
  } else {
    startObserver();
  }
})();
